module.exports = __webpack_public_path__ + "img/glasses-img.9d6409b3.png";